import { BaseService } from '../services/base-service.service';
import { FonteDadosMonitoramento } from './fonte-dados-monitoramento.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FonteDados } from '../fonte-dados/fonte-dados.model';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class FonteDadosMonitoramentoService extends BaseService<FonteDadosMonitoramento, number> {
  constructor(http: HttpClient) {
    super('fonteDadosMonitoramento', http);
  }

  public monitorar(fonteDados: FonteDados): Promise<FonteDadosMonitoramento> {
    return firstValueFrom(this.http.get<FonteDadosMonitoramento>(this.path(`monitorar/${fonteDados.id}`)));
  }

  public recuperarMaisRecentePorFonteDadosId(fonteDados: FonteDados): Promise<FonteDadosMonitoramento> {
    return firstValueFrom(
      this.http.get<FonteDadosMonitoramento>(this.path(`recuperarMaisRecentePorFonteDadosId/${fonteDados.id}`))
    );
  }
}
